import Amount from '../components/Common/Amount'
import { numVal } from '../modules/Utils'
import React from 'react'

function AmountDetails(props) {
  const { doc, currency } = props
  return (
    <Amount
      data={[
        {
          name: 'SUB-TOTAL (NET)',
          amount: numVal(doc, 'subTotal.net'),
        },
        {
          name: 'TAX',
          amount: numVal(doc, 'subTotal.tax'),
        },
        {
          name: 'TOTAL (GROSS)',
          amount: numVal(doc, 'subTotal.gross'),
        },
      ]}
      currency={currency || doc.currency}
    />
  )
}

export default AmountDetails
